import React from 'react';
import InfoBox from './InfoCard';
import {PaginationWrapper} from '../../Utility/PaginationWrapper';
import {PaginationListType} from '../../../Types/PaginationParams';
import useSearchFilter from '../../../Hooks/useSearchFilter';
import SearchFilter from '../../Utility/SearchFilter';

interface PaginatedCardProps<T> {
    title: string;
    itemsPerPage?: number
    listType: PaginationListType;
    renderItem: (item: T, index: number) => React.ReactNode;
    HeaderSlot?: React.ComponentType;
    itemsFunction: (
        page: number,
        itemsPerPage: number,
        optionalParams?: Record<string, string>,
        query?: string | null,
    ) => Promise<{ data: { data: T[]; total: number } }> | any;
}

function PaginatedCard<T>({title, itemsFunction, renderItem, listType, itemsPerPage = 7, HeaderSlot}: PaginatedCardProps<T>) {
    const {query, localQuery, searchActions} = useSearchFilter({
        initialQuery: null,
    });

    return (
        <InfoBox
            title={title}
            value=""
        >
            {HeaderSlot ? <HeaderSlot/> : <></>}
            <SearchFilter
                value={localQuery}
                onChange={searchActions.setLocalQuery}
                onApply={searchActions.applyQuery}
                onClear={searchActions.clearQuery}
                className="mb-3"
            />

            <PaginationWrapper<T>
                listType={listType}
                itemsFunction={itemsFunction}
                itemsPerPage={itemsPerPage}
                query={query ?? null}
                renderItem={renderItem}
            />
        </InfoBox>
    );
}

export default PaginatedCard;
